/*
*@param s : 时间秒
*/
var secondsFormat = ( s ) => {
  var day = Math.floor( s/ (24*3600) ); // Math.floor()向下取整
  var hour = Math.floor( (s - day*24*3600) / 3600) < 10 ? '0' + Math.floor( (s - day*24*3600) / 3600) : Math.floor( (s - day*24*3600) / 3600)
  var minute = Math.floor( (s - day*24*3600 - hour*3600) /60 ) < 10 ? '0' + Math.floor( (s - day*24*3600 - hour*3600) /60 ) : Math.floor( (s - day*24*3600 - hour*3600) /60 )
  var second = s - day*24*3600 - hour*3600 - minute*60 < 10 ? '0' + (s - day*24*3600 - hour*3600 - minute*60) : (s - day*24*3600 - hour*3600 - minute*60)
  if (day > 0) {
    return {type: 'day', value: day}
  } else {
    return {value: hour + ':' + minute + ':' + second, type: 'time'}
  }
}
export default secondsFormat


// WEBPACK FOOTER //
// ./src/util/secondsFormat.js